(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-info-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nv-info-bar')) {
  customElements.define('nv-info-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.messages = [...this.querySelectorAll('.nv-info__messages p')];
      this.index = Math.max(0, this.messages.findIndex(message => !message.hidden));
      this.hovered = this.matches(':hover');
      // Rotate text even with Reduce Motion enabled. CSS already disables the fade.
      this.paused = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseButton.hidden = false;
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => { queueMicrotask(() => this.schedule()); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.updatePause();
      this.schedule();
    }
    updatePause() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Reanudar mensajes' : 'Pausar mensajes');
      this.pauseButton.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
    }
    advance(direction, manual = false) {
      if (this.messages.length < 2) return;
      this.messages[this.index].hidden = true;
      this.index = (this.index + direction + this.messages.length) % this.messages.length;
      this.querySelector('.nv-info__messages').setAttribute('aria-live', manual ? 'polite' : 'off');
      this.messages[this.index].hidden = false;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const keyboardFocus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      if (!this.isConnected || this.messages.length < 2 || this.paused || document.hidden || keyboardFocus) return;
      this.timer = setTimeout(() => this.advance(1), 4500);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; this.hovered = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
